import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { WorkflowEditForm } from "./components/WorkflowEditForm";

export function EditWorkflowPage() {
  return (
    <Page title="Edit Workflow">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <WorkflowEditForm />
      </Container>
    </Page>
  );
}
